module.exports = __webpack_public_path__ + "media/audio60.1d7a2748.mp3";